export const phoneRegex: RegExp =
    /^\+?\d{1,4}\s?\(?\d{2,4}\)?[\s.-]?\d{3}[\s.-]?\d{2}[\s.-]?\d{2}$/;

export const isValidPhone = (phone: string): boolean =>
  phoneRegex.test(phone.trim());

export const telegramRegex: RegExp = /^@\w{2,}$/;

export const isValidTelegram = (telegram: string): boolean =>
  telegramRegex.test(telegram.trim());

export const emailRegex: RegExp = /^\S+@\S+\.\S+$/;

export const isValidEmail = (email: string): boolean =>
  emailRegex.test(email.trim());
